import { render, staticRenderFns } from "./ButtonsDoc.vue?vue&type=template&id=3d7ae258&scoped=true&"
import script from "./ButtonsDoc.vue?vue&type=script&lang=js&"
export * from "./ButtonsDoc.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsDoc.vue?vue&type=style&index=0&id=3d7ae258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ae258",
  null
  
)

export default component.exports